<template>
  <v-container fluid fill-height class="custom--container">
    <v-row align-center justify="center">
      <v-col cols="8" offset="2">
        <v-card color="white" class="elevation-0 custom--card">
          <v-card-title class="justify-center">
            <div class="contact--heading">Find Me Here:</div>
          </v-card-title>
          <v-card-text class="contact--text">
            <!-- email -->
            <v-btn :href="contact.email.link" target="__blank">
              <v-icon large>mdi-email</v-icon>:
              {{ contact.email.display }}
            </v-btn>
            <br />
            <!-- github -->
            <v-btn :href="contact.github.link" target="__blank">
              <v-icon large>mdi-github</v-icon>:
              {{ contact.github.display }}
            </v-btn>
            <br />
            <!-- linkedin -->
            <v-btn :href="contact.linkedin.link" target="__blank">
              <v-icon large>mdi-linkedin</v-icon>:
              {{ contact.linkedin.display }}
            </v-btn>
            <br />
            <!-- medium -->
            <v-btn :href="contact.medium.link" target="__blank">
              <v-icon large>mdi-post</v-icon>:
              {{ contact.medium.display }}
            </v-btn>
            <br />
          </v-card-text>
        </v-card>
      </v-col>
      <scroll-helper :scroll="contact.scroll" />
    </v-row>
  </v-container>
</template>

<script>
import ScrollHelper from "./ScrollHelper.vue";
export default {
  components: { ScrollHelper },
  name: "Contact",
  props: ["contact"],
};
</script>
